import React, { Component, Fragment } from 'react';

import Desktop from './Desktop/Desktop';

export default class Panel extends Component {
  render() {
    const { setOpenPanel } = this.props;
    return (
      <Fragment>
        <Desktop setOpenPanel={setOpenPanel} />
      </Fragment>
    );
  }
}